
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M6.307 16.64v-1.9M11 16.638v-3.795M15.693 16.636v-5.7","opacity":".4"}}),_c('g',{attrs:{"opacity":".4"}},[_c('path',{attrs:{"d":"M15.694 5.362l-.422.495a17.309 17.309 0 01-8.965 5.537"}}),_c('path',{attrs:{"d":"M13.008 5.362h2.686v2.677","stroke-linejoin":"round"}})]),_c('path',{attrs:{"d":"M8.25 20.166h5.5c4.583 0 6.417-1.833 6.417-6.417v-5.5c-.001-4.583-1.834-6.416-6.417-6.416h-5.5c-4.584 0-6.417 1.833-6.417 6.417v5.5c0 4.583 1.833 6.416 6.417 6.416z","stroke-linejoin":"round"}})])])
          )
        }
      }
    